import React from 'react'
import { arrayOf, string, object } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import MajorList from 'components/atoms/MajorList'
import Markdown from 'components/atoms/MarkdownContent'
import TogaSvg from 'components/atoms/SVGIcons/Toga'

import SectionTitleWithIcon from 'components/molecules/SectionTitleWithIcon'

const CareerMajors = ({ title, subtitle, list }) => (
  <div id="related-majors" className="career-majors">
    <SectionContainer
      paddingBottom={120}
    >
      <Container>
        <div className="career-majors__flex">
          <SectionTitleWithIcon
            icon={props => <TogaSvg fill="#0FC3C4" height="48px" width="48px" {...props}/>}
            title={title}
            stacked
          />
          <div className="career-majors__content">
            <Markdown className="career-majors__detail" content={subtitle} />
            <MajorList list={list} />
          </div>
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .career-majors {
          &__detail {
            margin-top: 32px;
          }
          :global(&__detail) {
            font-size: 16px;
            line-height: 1.5;
            :global(p) {
              margin-bottom: 8px;
            }
            @media screen and (min-width: 768px) {
              background-color: #fff;
              :global(p) {
                margin-bottom: 16px;
              }
            }
          }
          @media screen and (min-width: 768px) {
            &__flex {
              display: flex;
            }
            &__content {
              flex: 1;
              margin: 64px 0 0 64px;
            }
          }
        }
      `}
    </style>
  </div>
)

CareerMajors.propTypes = {
  title: string,
  subtitle: string,
  list: arrayOf(object),
}

export default CareerMajors
